export default "__VITE_ASSET__DAcmPoW9__ 640w, __VITE_ASSET__x$D5beu0__ 1024w, __VITE_ASSET__BLnS4OXu__ 1536w";